// A short fingerprint of a field's stored value, for a React key.
//
// The read-only rich-text renderer (TipTap) takes its content once, on mount:
// a new value handed to a mounted editor is never drawn. The work item panel
// keys that editor so it mounts again when the content changes — and the key
// carried only the field, the value's type and the attachments, so a rich-text
// field written by something else on the screen (a field view's save, e.g. the
// RUN TOGGLE stopwatch writing Time Logs, 2026-10-21) kept showing the old
// text until the page was reloaded. The key now carries this fingerprint.
//
// FNV-1a over the JSON text, base 36. An object's fingerprint is remembered
// per object (a WeakMap), so a panel re-render does not hash the same ADF
// document again; a stored value is replaced, never mutated, when it changes.

const memo = new WeakMap();

function fnv1a(text) {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(36);
}

export function contentFingerprint(value) {
  if (value == null) return '0';
  if (typeof value !== 'object') return fnv1a(String(value));
  const known = memo.get(value);
  if (known) return known;
  let text;
  try { text = JSON.stringify(value); } catch { text = ''; }
  const key = `${fnv1a(text || '')}.${(text || '').length.toString(36)}`;
  memo.set(value, key);
  return key;
}

export default contentFingerprint;
